import { render, staticRenderFns } from "./flowFund.vue?vue&type=template&id=f132312e"
import script from "./flowFund.vue?vue&type=script&lang=js"
export * from "./flowFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports